<template>
  <div class="sms-bill">
    <!-- 查询条件 -->
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form inline @submit.prevent="query(1)">
          <el-form-item label="年份">
            <el-date-picker v-model="queryYear" clearable placeholder="请选择" type="year" value-format="YYYY" />
          </el-form-item>
          <el-form-item label="月份">
            <el-select v-model="queryMonth" clearable placeholder="请选择">
              <el-option v-for="m in 12" :key="m" :label="m" :value="m" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="search" type="primary" @click="query(1)">查询</el-button>
            <el-link
              :disabled="exporting"
              style="margin-left: 12px"
              type="primary"
              :underline="false"
              @click="handleExport"
            >
              {{ exporting ? '导出中...' : '导出' }}
            </el-link>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column align="center" label="月份" prop="month" />
      <el-table-column align="center" label="发送量" prop="sendCount" />
      <el-table-column align="center" label="操作">
        <template #default="{ row }">
          <el-link :disabled="exportingDetail" type="primary" :underline="false" @click="handleExportDetail(row)">
            {{ exportingDetail ? '导出中...' : '导出明细' }}
          </el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted } from 'vue'
  import { querySmsBill, exportSmsBill, exportSmsRecord } from '@/api/sms'
  import { omit } from 'lodash'

  const currentYear = new Date().getFullYear()

  const queryYear = ref(String(currentYear))
  const queryMonth = ref('')

  const queryParams = reactive({
    pageNum: 1,
    pageSize: 20,
    total: 0,
  })

  const loading = ref(false)
  const tableData = ref([])

  onMounted(() => {
    query()
  })

  function buildParams() {
    const params = {}
    if (queryYear.value) params.year = Number(queryYear.value)
    if (queryMonth.value) params.month = Number(queryMonth.value)
    return params
  }

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...buildParams(),
      pageNum,
      pageSize: queryParams.pageSize,
    }

    loading.value = true
    querySmsBill(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list = [], total = 0 } = data || {}
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  // ---- 导出汇总 ----
  const exporting = ref(false)

  function handleExport() {
    const params = {
      ...buildParams(),
      pageNum: queryParams.pageNum,
      pageSize: queryParams.pageSize,
    }
    exporting.value = true
    exportSmsBill(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        if (data?.fileUrl) window.open(data.fileUrl)
      })
      .finally(() => {
        exporting.value = false
      })
  }

  // ---- 导出明细（按月份导出发送记录） ----
  const exportingDetail = ref(false)

  function handleExportDetail(row) {
    if (!row.month) return
    const [year, month] = row.month.split('-')
    const startDate = `${year}-${month}-01`
    // 计算月末日期
    const endDate = getLastDayOfMonth(Number(year), Number(month))
    exportingDetail.value = true
    exportSmsRecord({ startDate, endDate })
      .then(({ code, data }) => {
        if (code !== 200) return
        if (data?.fileUrl) window.open(data.fileUrl)
      })
      .finally(() => {
        exportingDetail.value = false
      })
  }

  function getLastDayOfMonth(year, month) {
    const d = new Date(year, month, 0)
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${d.getFullYear()}-${mm}-${dd}`
  }
</script>

<style lang="scss" scoped>
  .sms-bill {
    padding: 16px;
  }
</style>
